import React from 'react';
import { useTranslation } from 'react-i18next';
import { PERMISSION_CATALOG } from 'utils/permissions';
import styles from './UserPane.module.css';

const UserPermissions = ({
  permissions = [],
}: {
  permissions?: string[];
}) => {
  const { t } = useTranslation();
  const granted = new Set(permissions);
  const known = new Set<string>(PERMISSION_CATALOG.map(item => item.id));
  const extra = permissions.filter(permission => !known.has(permission));

  return (
    <ul className={styles.permissions}>
      {
        PERMISSION_CATALOG.map(item => {
          const hasPermission = granted.has(item.id);
          return (
            <li key={item.id}>
              <span>{t(item.labelKey)}</span>
              <span className={hasPermission ? styles.granted : styles.notGranted}>
                {hasPermission ? t('granted') : t('notGranted')}
              </span>
            </li>
          );
        })
      }
      {
        extra.map(permission => (
          <li key={permission}>
            <span>{permission}</span>
            <span className={styles.granted}>{t('granted')}</span>
          </li>
        ))
      }
    </ul>
  );
};

export default UserPermissions;
